<template>
  <div>
    <el-container style="padding: 0px;margin: 0px">
      <el-header>
        <!-- 标题文字 -->
        <div class="box">
          <h1>
            <a id="el-header-link" target="_blank" href="https://jq.qq.com/?_wv=1027&k=5nzxHQN">
              <i class="el-icon-link"></i>
              <span style="--i:1">纪</span>
              <span style="--i:2">堂</span>
              <span style="--i:3">方</span>
              <span style="--i:4">舟</span>
              <span style="--i:5">2</span>
              <span style="--i:6">7</span>
              <span style="--i:7">2</span>
              <span style="--i:8">6</span>
              <span style="--i:9">-</span>
              <span style="--i:10">三</span>
              <span style="--i:11">年</span>
              <span style="--i:12">优</span>
              <span style="--i:13">质</span>
              <span style="--i:14">专</span>
              <span style="--i:15">业</span>
              <span style="--i:16">模</span>
              <span style="--i:17">组</span>
              <span style="--i:18">服</span>
            </a>
          </h1>
        </div>

      </el-header>
      <el-container>
        <!--侧边导航-->
        <el-aside>
          <el-menu
              router
              :default-active="activeMenuItemPath"
              class="el-menu-Header"
              mode="vertical"
              text-color="white"
              active-text-color="#409eff">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/Manager/About">本服简介</el-menu-item>
            <el-menu-item index="/Manager/Gonggao">服务器公告</el-menu-item>
            <el-menu-item index="/Manager/Howjoin">收藏法进服</el-menu-item>
            <el-menu-item index="/Manager/Epoch">纪元攻略</el-menu-item>
            <el-menu-item>
              <el-link id="el-aside-ek-linkplayer" icon="el-icon-link"
                       href="http://www.jtark2726.com:9082"
                       target="_blank">玩家中心
              </el-link>
            </el-menu-item>
            <el-menu-item>
              <el-link id="el-aside-ek-link" icon="el-icon-link"
                       href="https://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=dMa-mS7_O-DdsWtbTsGuNlX1LISxfAK4&authKey=HQGk8QyenpoTguQWTeypirv9nQwrCFI8G7XWa1e6bm1%2BHf94NznqMvNzKu8u5RXh&noverify=0&group_code=566101559"
                       target="_blank">加群
              </el-link>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <!--内容区-->
        <el-main id="el-main-homeview">
          <el-card class="el-card-homeview-display-container">
            <el-carousel :interval="4000" type="card">
              <el-carousel-item v-for="(index,item) in Arrayimage" :key="item">
                <img :src="index" style="height: 360px;width: 100%;" alt="">
              </el-carousel-item>
            </el-carousel>
            <!--将由其他视图组件来显示-->
            <router-view/>

            <!--分割线-->
            <el-divider class="el-divider--horizontal-header"></el-divider>
            <!--仿官区说明-->
            <!--模组区说明-->
            <el-row :gutter="5">
              <el-col :span="12">
                <el-card class="el-card-homeview-display-header">
                  <h1 style="text-align: left">
                    <span style="color: red">大型模组区 / 仿官区
                      <el-link style="color: red" icon="el-icon-link"
                        href="https://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=dMa-mS7_O-DdsWtbTsGuNlX1LISxfAK4&authKey=HQGk8QyenpoTguQWTeypirv9nQwrCFI8G7XWa1e6bm1%2BHf94NznqMvNzKu8u5RXh&noverify=0&group_code=566101559"
                        target="_blank">加群:566101559
                      </el-link></span>
                    &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
                  </h1>
                  <h2><span style="color: aqua;text-shadow: 2px 2px purple">★萌新天堂，大佬飞升★</span></h2>
                  <h3>
                    <span style="color: blue;text-shadow: 2px 2px yellow">收藏法进服教程请移步左侧《收藏法进服》</span>
                    <span style="color: yellow;text-shadow: 2px 2px blue">内含如何Q群绑定游戏角色；</span><br>
                    <br>
                    <div class="box2">
                      <span style="--i:19;text-shadow: 2px 2px white">←玩家中心【物理服专用】</span>
                      登录后可
                      <span style="--i:20;text-shadow: 2px 2px white">自助管理个人信息</span>
                    </div>
                  </h3>
                  <el-tag style="margin: 5px">服务器已运行：{{ appRunTime }}</el-tag>
                  <br>
                  <audio id="bg-audios" controls="controls" loop="loop" src="/∀ - Start.mp3"
                         autoplay></audio>
                </el-card>
              </el-col>
              <el-col :span="12">
                <el-card class="el-card-homeview-display-header">
                  <h4 style="text-align: center"><span style="color: red">直连教程（已作废，左边用收藏IP进服）</span><span
                      style="color: red">（请仔细查看）</span>
                  </h4>
                  <span>①打开此网页后，鼠标点击下方每个地图下的<i class="el-icon-link"></i>链接即可</span><br>
                  <span>②点击之后，网页弹框点“确定”或者“打开”，然后就等着自动打开游戏<span
                      style="color: red">（重要）</span></span><br>
                  <span>③游戏打开后<span style="color: red">啥也不要点！（重要）</span></span><br>
                  <img src="/img/直连页面.png" style="width: 75%;height: 75%"><br>
                  <span>④这时候正常情况，右下角会出现以英文”Install“开头的，等待英文消失后等待一分钟就可以进服了！<span
                      style="color: red">（重要）</span></span><br>
                  <span>⑤如果出现连接超时，查看steam下载，下载完成后重新直连即可，如此反复<span
                      style="color: red">（重要）</span></span>
                </el-card>
              </el-col>
            </el-row>

            <el-divider class="el-divider-modline"><span style="color: darkorange;font-weight: bolder;font-size: x-large">
              模&nbsp&nbsp&nbsp&nbsp&nbsp组&nbsp&nbsp&nbsp&nbsp&nbsp分&nbsp&nbsp&nbsp&nbsp&nbsp区（大型生物模组）
            </span></el-divider>
            <!--物理机分区-->

            <!--TODO        物理机      1服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/lostland.jpg" alt="2726方舟-迷失岛">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server1ip" target="_blank">迷失岛 Omega/2.0
                      <span><i class="el-icon-magic-stick"></i></span></el-link>
                    <br>①服
                    已运行:{{ wljappRunTime1 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server1ip" target="_blank"><span style="font-size: x-large">1服-----迷失岛 Omega/2.0</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：5倍 | 孵化：5倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：Omega、原神、s+、自助找龙、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO        物理机      2服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/alps.jpg" alt="2726方舟-阿尔卑斯">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server2ip" target="_blank">阿尔卑斯 高阶恐惧/v360纪元
                      <span><i class="el-icon-medal-1"></i></span></el-link>
                    <br>②服
                    已运行:{{ wljappRunTime2 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server2ip" target="_blank"><span style="font-size: x-large">2服-----阿尔卑斯 高阶恐惧/v360纪元</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：5倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：5~35倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★★</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：纪元、原始恐惧、原恐扩展*2、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：5人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.152倍 夜晚：白天=1:10</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO      物理机        3服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server3ip" target="_blank">仙境 中阶恐惧/v360纪元
                      <span><i class="el-icon-medal"></i></span>
                    </el-link>
                    <br>③服
                    已运行:{{ wljappRunTime3 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server3ip" target="_blank"><span style="font-size: x-large">3服-----仙境 中阶恐惧/v360纪元</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：3倍 | 驯服：6倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：纪元、原始恐惧、原恐扩展*2、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升150 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.152倍 夜晚：白天=1:10</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--第二行-->
            <!--TODO       物理机       4服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server4ip" target="_blank">仙境 神话演变养老
                      <span><i class="el-icon-collection-tag"></i></span></el-link>
                    <br>④服
                    已运行:{{ wljappRunTime4 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server4ip" target="_blank"><span style="font-size: x-large">4服-----仙境 神话演变养老</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：神话演变12、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升150 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.076倍 夜晚：白天=1:10</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       5服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server5ip" target="_blank">仙境 深渊·血月末日
                      <span><i class="el-icon-collection-tag"></i></span></el-link>
                    <br>⑤服
                    已运行:{{ wljappRunTime5 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server5ip" target="_blank"><span style="font-size: x-large">5服-----仙境 深渊·全扩展</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：3倍 | 驯服：3倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：深渊、深渊扩展、现代枪械、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升60 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.076倍 夜晚：白天=2:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       6服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/NewARKEpoch.png" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server6ip" target="_blank">仙境 v360纯净纪元/2.0
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑥服
                    已运行:{{ wljappRunTime6 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server6ip" target="_blank"><span style="font-size: x-large">6服-----仙境 v360纯净纪元/2.0</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：纪元、RR建筑、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升60 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       7服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/NewARKEpoch.png" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server7ip" target="_blank">仙境 v358纪元/惊变
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑦服
                    已运行:{{ wljappRunTime7 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server7ip" target="_blank"><span style="font-size: x-large">7服-----仙境 v358纪元/惊变</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：纪元、惊变一百天、RR建筑、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       8服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Viking.png" alt="2726方舟-维京">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server8ip" target="_blank">维京湾 耐玩纯净永恒
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑧服
                    已运行:{{ wljappRunTime8 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server8ip" target="_blank"><span style="font-size: x-large">8服-----维京湾 耐玩纯净永恒</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：永恒、木屋建筑、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       9服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server9ip" target="_blank">仙境 AG重生
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑨服
                    已运行:{{ wljappRunTime9 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server9ip" target="_blank"><span style="font-size: x-large">9服-----仙境 AG重生</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：AG重生、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       10服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Valguero.jpg" alt="2726方舟-瓦尔盖罗">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server10ip" target="_blank">瓦尔盖罗 纯净恐惧全扩展/2.0
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩服
                    已运行:{{ wljappRunTime10 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server10ip" target="_blank"><span style="font-size: x-large">10服-----瓦尔盖罗 纯净恐惧全扩展/2.0</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：纪元、恐惧（+扩展）、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       11服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/TheCenter.jpg" alt="2726方舟-中心岛">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server11ip" target="_blank">中心岛 灭绝[野人2]
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩①服
                    已运行:{{ wljappRunTime11 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server11ip" target="_blank"><span style="font-size: x-large">11服-----中心岛 灭绝[野人2]</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：灭绝Core、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       12服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/sjd.png" alt="2726方舟-怪猎萌新图">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server12ip" target="_blank">水晶岛 怪物猎人低位图
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩②服
                    已运行:{{ wljappRunTime12 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server12ip" target="_blank"><span style="font-size: x-large">12服-----水晶岛 怪物猎人低位图</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：怪物猎人本体、lm定制龙、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：4人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       13服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server13ip" target="_blank">仙境 怪物猎人萌新图
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩③服
                    已运行:{{ wljappRunTime13 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server13ip" target="_blank"><span style="font-size: x-large">13服-----仙境 怪物猎人萌新图</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：怪物猎人本体、lm定制龙、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：4人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       14服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server14ip" target="_blank">仙境 怪物猎人孵蛋图
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩③服
                    已运行:{{ wljappRunTime14 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server14ip" target="_blank"><span style="font-size: x-large">14服-----仙境 怪物猎人孵蛋图</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：怪物猎人本体、lm定制龙、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：4人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO       物理机       15服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/ScorchedEarth.jpg" alt="2726方舟-焦土">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server15ip" target="_blank">截图 怪物猎人BOSS高位图
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑩③服
                    已运行:{{ wljappRunTime15 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             :href="server15ip" target="_blank"><span style="font-size: x-large">15服-----焦土 怪物猎人BOSS高位图</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：5倍 | 驯服：5倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：全部默认1倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★★★★</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：怪物猎人本体、lm定制龙、灵魂球、s+、A镜、唯一集成、传送器、叠加</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物150</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：4人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：0.3倍 夜晚：白天=1:5</span><br>

                </el-card>
              </el-col>
            </el-row>


            <el-divider><span style="color: red;font-weight: bolder;font-size: larger">
              仿&nbsp&nbsp&nbsp&nbsp&nbsp官&nbsp&nbsp&nbsp&nbsp&nbsp分&nbsp&nbsp&nbsp&nbsp&nbsp区（模组区在下面）
            </span></el-divider>
            <!--维姆机分区-->
            <!--FWQ区第一行-->
            <el-row :gutter="5">
              <!--TODO              1服-->
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/TheIsland.jpg" alt="2726方舟-孤岛">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 孤岛
                      <span><i class="el-icon-magic-stick"></i></span></el-link>
                    <br>①服
                    已运行:{{ appRunTime1 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 孤岛</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px gold;">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO              2服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Ragnarok.jpg" alt="2726方舟-仙境">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 仙境
                      <span><i class="el-icon-medal-1"></i></span></el-link>
                    <br>②服
                    已运行:{{ appRunTime2 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 仙境</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO              3服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Viking.png" alt="2726方舟-焦土">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 维京土
                      <span><i class="el-icon-medal"></i></span>
                    </el-link>
                    <br>③服
                    已运行:{{ appRunTime3 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 维京</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--第二行-->
            <el-row :gutter="5">
              <!--TODO              4服-->
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Aberration.jpg" alt="2726方舟-畸变">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 畸变
                      <span><i class="el-icon-collection-tag"></i></span></el-link>
                    <br>④服
                    已运行:{{ appRunTime4 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 畸变</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO              5服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Extinction.jpg" alt="2726方舟-灭绝">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 灭绝
                      <span><i class="el-icon-collection-tag"></i></span></el-link>
                    <br>⑤服
                    已运行:{{ appRunTime5 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 灭绝</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO              6服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Genesis.jpg" alt="2726方舟-创一">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 创世纪一
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑥服
                    已运行:{{ appRunTime6 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 创世纪一</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--TODO              7服-->
            <el-row :gutter="5">
              <el-col :span="8">
                <el-card class="el-card-homeview-display-main">
                  <div class="divimg">
                    <img src="/img/Gen2.png" alt="2726方舟-创二">
                  </div>
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank">仿官服之 创世纪二
                      <span><i class="el-icon-star-off"></i></span></el-link>
                    <br>⑦服
                    已运行:{{ appRunTime7 }}
                  </div>
                </el-card>
              </el-col>
              <el-col :span="16">
                <el-card class="el-card-homeview-display-about" style="background-color: rgba(255, 255, 255, 0)!important;">
                  <div>
                    <el-link icon="el-icon-link"
                             href="https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined" target="_blank"><span style="font-size: x-large">仿官服之 创世纪二</span>
                      <span><i class="el-icon-magic-stick"></i>（点击进服）</span></el-link>
                    <br>
                  </div>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">采集：10倍 | 驯服：10倍 | 成长：10倍 | 孵化：10倍 | 交配：5倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">属性：龙默认1倍 | 人物升级属性保底2倍</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">难度：★★☆☆☆</span><br>
                  <span
                      style="color: white;text-shadow: 2px 2px orange">主要模组列表：A镜、叠加、板传、活动色</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">等级情况：野生龙150 驯服升120 人物不飞升120</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">模式：PVE</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">最大部落人数：10人</span><br>
                  <span style="color: white;text-shadow: 2px 2px orange">时间循环速度：1倍 夜晚：白天=1:1</span><br>

                </el-card>
              </el-col>
            </el-row>

            <!--分割线-->
            <el-divider></el-divider>
            <el-card class="el-card-homeview-display-footer">
              <h4>二次直连教程</h4>
              <p>打开此网页后，鼠标点击下方每个地图下的<i class="el-icon-link"></i>链接即可</p>
              <p>点击之后，网页会弹框，点击“确定”或者“打开”，然后就等着自动打开游戏<span style="color: red">（重要）</span></p>
              <p><span style="color: red">游戏打开后啥也不要点！等待进服就行！（重要）</span></p>

              <h1>祝大家游戏愉快!</h1>
              <h5><span style="color: Yellow;text-shadow: 2px 2px blue">特此声明：氪金随意，支持可以赞助，不赞助也可当公益服游玩！</span>
              </h5>
              <h3><span style="color: Yellow;text-shadow: 2px 2px blue">特此声明：本服VIP永久有效，全服通用，专属VIP礼包，保值划算！</span>
              </h3>
              <h1><span style="color: Yellow;text-shadow: 2px 2px blue">特此声明：对本服的所有赞助都用于服务器维护费用!</span>
              </h1>
            </el-card>
          </el-card>
        </el-main>

        <el-footer>
          <div class="container">
            <p class="text-center">Copyright © 2022 2726·方舟 All rights reserved.</p>
            <p class="text-center">
              <el-link href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2022013965号</el-link>
            </p>
          </div>
        </el-footer>

      </el-container>
    </el-container>
  </div>
</template>
<style>
.el-carousel-item {
  margin: 0 auto;
  height: 360px!important;
}

.el-divider--horizontal-header {
  margin-top: 0 !important;
  margin-bottom: 10px !important;
}
.el-divider-modline{
  background-color: rgba(255,255,255,0.75)!important;
}
.el-divider__text {
  background-color: rgba(255,255,255,0.75)!important;
  border-radius: 14px;
}
.el-card-homeview-display-about{
  background-color: rgba(255, 150, 0, 0.3)!important;
}
</style>
<script>
export default {
  data() {
    return {

      activeMenuItemPath: '',
      appRunTime: '',
      appRunTime1: '',
      appRunTime2: '',
      appRunTime3: '',
      appRunTime4: '',
      appRunTime5: '',
      appRunTime6: '',
      appRunTime7: '',

      wljappRunTime: '',
      wljappRunTime1: '',
      wljappRunTime2: '',
      wljappRunTime3: '',
      wljappRunTime4: '',
      wljappRunTime5: '',
      wljappRunTime6: '',
      wljappRunTime7: '',
      wljappRunTime8: '',
      wljappRunTime9: '',
      wljappRunTime10: '',
      wljappRunTime11: '',
      wljappRunTime12: '',
      wljappRunTime13: '',
      wljappRunTime14: '',
      wljappRunTime15: '',
      Arrayimage: [
        "/img/希望图毕业1.jpeg",
        "/img/恐惧档毕业照2.jpg",
        "/img/瓦盖高难毕业1.jpg",
        "/img/苍老灭绝毕业.jpg",
        "/img/仓老11服灭绝毕业.png",
      ],
      server1ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server2ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server3ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server4ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server5ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server6ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server7ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server8ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server9ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server10ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server11ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server12ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server13ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server14ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      server15ip: "https://docs.qq.com/doc/DS1BYakNkQXNXRUl2?u=undefined",
      // server13ip: "steam://run/346110//+connect 47.99.117.138:27170",
    }
  },
  methods: {
    handleActiveMenuItem() {
      let currentPath = this.$router.currentRoute.path;
      if (currentPath.startsWith('/Manager/Index')) {
        currentPath = '/Manager/Index';
      }
      if (currentPath.startsWith('/Manager/About')) {
        currentPath = '/Manager/About';
      }
      if (currentPath.startsWith('/Manager/Gonggao')) {
        currentPath = '/Manager/Gonggao';
      }
      if (currentPath.startsWith('/Manager/Howjoin')) {
        currentPath = '/Manager/Howjoin';
      }
      if (currentPath.startsWith('/Manager/Epoch')) {
        currentPath = '/Manager/Epoch';
      }

      this.activeMenuItemPath = currentPath;
    },
  },
  created() {

  },
  mounted() {
    let that = this
    let timerall = ''
    let timer1 = ''
    let timer2 = ''
    let timer3 = ''
    let timer4 = ''
    let timer5 = ''
    let timer6 = ''
    let timer7 = ''

    let wljtimer1 = ''
    let wljtimer2 = ''
    let wljtimer3 = ''
    let wljtimer4 = ''
    let wljtimer5 = ''
    let wljtimer6 = ''
    let wljtimer7 = ''
    let wljtimer8 = ''
    let wljtimer9 = ''
    let wljtimer10 = ''
    let wljtimer11 = ''
    let wljtimer12 = ''
    let wljtimer13 = ''
    let wljtimer14 = ''
    let wljtimer15 = ''
    /*服务器总运行时间*/
    timerall = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2019-10-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*①服运行时间*/
    timer1 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime1 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*②服运行时间*/
    timer2 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime2 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*③服运行时间*/
    timer3 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime3 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*④服运行时间*/
    timer4 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime4 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*⑤服运行时间*/
    timer5 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime5 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*⑥服运行时间*/
    timer6 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime6 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*⑦服运行时间*/
    timer7 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.appRunTime7 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);

    /*模组分区*/

    /*物理机①服运行时间*/
    wljtimer1 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime1 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机②服运行时间*/
    wljtimer2 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2026-01-01 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime2 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机③服运行时间*/
    wljtimer3 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime3 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机④服运行时间*/
    wljtimer4 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime4 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑤服运行时间*/
    wljtimer5 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime5 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑥服运行时间*/
    wljtimer6 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime6 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑦服运行时间*/
    wljtimer7 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-05-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime7 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑧服运行时间*/
    wljtimer8 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime8 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑨服运行时间*/
    wljtimer9 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime9 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩服运行时间*/
    wljtimer10 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-10-18 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime10 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩①服运行时间*/
    wljtimer11 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-01-25 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime11 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩②服运行时间*/
    wljtimer12 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-07-15 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime12 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩③服运行时间*/
    wljtimer13 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-07-15 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime13 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩④服运行时间*/
    wljtimer14 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-07-15 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime14 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);
    /*物理机⑩⑤服运行时间*/
    wljtimer15 = window.setInterval(function logname() {
      let staytimeGap = new Date().getTime() - new Date('2025-07-15 00:00:00').getTime();
      let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
      let leave = staytimeGap % (3600 * 1000 * 24);
      let stayHour = Math.floor(leave / (3600 * 1000));
      let leave1 = leave % (3600 * 1000);
      let stayMin = Math.floor(leave1 / (60 * 1000));
      let leave2 = leave1 % (60 * 1000);
      let staySec = Math.floor(leave2 / 1000);
      that.wljappRunTime15 = stayDay + "天" + stayHour + "时" + stayMin + "分" + staySec + "秒";
    }, 1000);

    this.handleActiveMenuItem();
  }
}
</script>